import { View } from './view'

export const ComfortFormat = View
